import { useFeedback } from '@/hooks/useFeedback';
import { useEffect } from 'react';
import { Outlet, unstable_useRouterState as useRouterState } from 'react-router';
import { isQuietNavigation } from '../handle';

export const RootLayout = () => {
  // useNavigation() 会剥掉 matches，useMatches() 只反映已提交的位置，
  // 只有这个 hook 能同时拿到在途导航的匹配链与其 handle
  const { active, pending } = useRouterState();
  const { startPseudoLoading, finishPseudoLoading } = useFeedback();

  // 静默跳转要整个跳过 start/finish：loading store 是单槽、非引用计数的，
  // 照调再关会掐掉同时段其他业务发起的遮罩
  const isLoading = pending?.state === 'loading' && !isQuietNavigation(active.matches, pending.matches);

  useEffect(() => {
    if (isLoading) {
      startPseudoLoading();
      return () => {
        finishPseudoLoading();
      };
    }
  }, [isLoading, finishPseudoLoading, startPseudoLoading]);

  return <Outlet />;
};
